import React, {useState} from 'react';
import chevronRight from '../assets/fi_chevron-right.svg';
import { useNavigate } from 'react-router-dom';
import downloadIcon from "../assets/fi_download.svg";
import BaseButton from "./BaseButton";
import { downloadInvoice } from "../services/_downloadInvoice";
import Loader from "./Loader";
import {useAuth} from "../context/AuthContext";

function RideHistoryItem({ ride, onClick, refCallback }) {
    const { user } = useAuth();
    const [isDownloading, setIsDownloading] = useState(false);
    const navigate = useNavigate();
    const handleClick = (route) => {
        navigate(route, { state: { fromRideHistory: true } });
    };

    const handleDownload = async (e, encodedId) => {
        e.stopPropagation();

        try {
            setIsDownloading(true);
            await downloadInvoice(encodedId);
        } catch (err) {
            console.error("Download failed", err);
        } finally {
            setIsDownloading(false);
        }
    };

    if (isDownloading) return <Loader />;

    return (
        <div
            className="rideHistoryItem"
            onClick={() => handleClick(`/ride/${ride.id}`)}
            ref={refCallback}
        >
            <div className="rideHistoryItem__labels">
                <div className="dateTime">
                    <p>{ride.date}</p>
                    <p className="divider">•</p>
                    <p>{ride.time}</p>
                </div>
                <p className="address">{ride.from}</p>
                <div className="rideHistoryItem__buttons">
                    <p className="price">{ride.price}€</p>
                </div>
            </div>
            <div className="rideHistoryItem__button">
                <img
                    className="js-iconDown"
                    src={chevronRight}
                    alt=""
                    loading="lazy"
                />
            </div>
        </div>
    );
}

export default RideHistoryItem;